module.exports = __webpack_public_path__ + "media/PAG71-04.09bc0c2c.mp3";